module.exports = __webpack_public_path__ + "9c200ba2dae3b4aeac2cb486d5413d40.pdf";